import { useState, useEffect } from 'preact/hooks';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import Text from '../../Global/Text';
import { updateTranslationTextForConfirmationAction } from '../../../actions/UserData'; 

const DynamicConfirmationSection = (props) => {

    const {
        className,
        dynamicTitle,
        dynamicSubHeader,
        userData,
        translations,
        values,
        setValues,
        dispatch
    } = props;

    const [purchasedProducts, setPurchasedProducts] = useState([
        {
            "key": "household",
            "insurance": "Indboforsikring",
            "price": "0",
            "color": "",
            "icon":  ""
        },
        {
            "key": "personal",
            "insurance": "Personforsikring",
            "price": "0",
            "color": "",
            "icon":  ""
        },
        {
            "key": "travel",
            "insurance": "Rejseforsikring",
            "price": "0",
            "color": "",
            "icon":  ""
        }
    ]);
    const [showContent, setShowContent] = useState(false);
    
    useEffect(() => {
        let failedInsuranceList = [];
        let succeededInsuranceList = [];
        const list = purchasedProducts.reduce((results, item) => {
            if(userData.basketList?.includes(item.key)) {
                if(!userData[`errorCalc-${item.key}`]) {
                    results.push( {
                        ...item,
                        "price": userData[`totalPrice-${item.key}`],
                        "color": "#2878ff",
                        "icon":  "check"
                    } );
                    succeededInsuranceList.push(item.insurance);
                } else {
                    results.push( {
                        ...item,
                        "price": userData[`totalPrice-${item.key}`],
                        "color": "",
                        "icon":  "x"
                    } );
                    failedInsuranceList.push(item.insurance);
                }
            }
            return results;
        }, []);

        if(failedInsuranceList.length === 0) {
            setShowContent(false);
        } else {
            setPurchasedProducts(list);
            dispatch(updateTranslationTextForConfirmationAction({
                purchaseFailureText: failedInsuranceList.join(', '),
                purchaseSuccessText: (succeededInsuranceList.length === 0)? "" : ` Dit køb af ${succeededInsuranceList.join(', ')} er gennemført.`
            }));
            setShowContent(true);
        }

    }, []);

    return (
        showContent ? <div className='dynamic-confirmation'>
            <Text className={'text__title'} component={'h4'} value={dynamicTitle} />
            <div className='dynamic-confirmation_inner'>
                <Text className={'text__body'} component="p" value={dynamicSubHeader} />
                <div className='combined-purchase-list'>
                    {
                        purchasedProducts.map(item => {
                            return (
                                <div className='combined-purchase-list-item'>
                                    <anchor-icon name={item.icon} size={'medium'} color={item.color}/>
                                    <Text value={ `${item.insurance} - ${Math.round(item.price)} kr./md.` } />
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div> : 
        <></>
    )
}

export default compose(
    connect(state => {
      const {
        section: {
          packageData: { translations },
        },
        userData
      } = state;
  
      return { translations, userData };
    })
)(DynamicConfirmationSection);
    
DynamicConfirmationSection.defaultProps = {
   
};
    
DynamicConfirmationSection.propTypes = {
    values: PropTypes.object.isRequired,
    translations: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    userData: PropTypes.object.isRequired
};